import React from "react";
import LandingPageSection from "../sections/LandingPageSection/Content";
const LandingPage = () => {
  return <LandingPageSection />;
};

export default LandingPage;
